import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  Box,
  Button,
  Typography,
  Alert,
} from '@mui/material';
import { Google } from '@mui/icons-material';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { loginWithGoogle, loginError } = useAuth();

  async function handleGoogle() {
    setLoading(true);
    try {
      if (await loginWithGoogle()) {
        navigate('/');
      }
    } finally {
      setLoading(false);
    }
  }

  const error = loginError;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      {/* Left Side - Branding/Visual */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flex: 1,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: 4,
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: 500 }}>
          <Box
            sx={{
              width: 120,
              height: 120,
              borderRadius: '50%',
              background: 'rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 30px',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            }}
          >
            <Typography variant="h1" sx={{ color: 'white', fontWeight: 700, fontSize: '4rem' }}>
              S
            </Typography>
          </Box>

          <Typography
            variant="h2"
            sx={{
              color: 'white',
              fontWeight: 700,
              mb: 2,
              fontSize: { xs: '2.5rem', md: '3.5rem' },
            }}
          >
            SejkanSync
          </Typography>

          <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.9)', mb: 4, lineHeight: 1.6 }}>
            Moderan admin panel za sinhronizaciju i upravljanje proizvodima
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, justifyContent: 'center', mt: 6 }}>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h3" sx={{ color: 'white', fontWeight: 700 }}>
                1000+
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                Proizvoda
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h3" sx={{ color: 'white', fontWeight: 700 }}>
                24/7
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                Sinhronizacija
              </Typography>
            </Box>
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h3" sx={{ color: 'white', fontWeight: 700 }}>
                99%
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)' }}>
                Uptime
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Right Side - Login Form */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: { xs: 3, md: 6 },
          backgroundColor: '#f8fafc',
        }}
      >
        <Box sx={{ width: '100%', maxWidth: 450 }}>
          <Box sx={{ mb: 6 }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
              Dobrodošli nazad
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary' }}>
              Prijavite se na svoj nalog da nastavite
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
              {error}
            </Alert>
          )}

          <Button
            fullWidth
            variant="outlined"
            onClick={handleGoogle}
            disabled={loading}
            startIcon={<Google />}
            sx={{
              py: 1.5,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: '1.05rem',
              fontWeight: 600,
              backgroundColor: 'white',
            }}
          >
            Prijavi se s Google nalogom
          </Button>

          <Typography variant="body2" sx={{ mt: 2, textAlign: 'center', color: 'text.secondary' }}>
            Pristup imaju samo odobreni Google nalozi.
          </Typography>

          <Typography variant="body2" sx={{ mt: 6, textAlign: 'center', color: 'text.secondary' }}>
            © 2024 SejkanSync. Sva prava zadržana.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
